export default "__VITE_ASSET__BIEVDi2I__"